import { render, staticRenderFns } from "./Relatorios.vue?vue&type=template&id=37138abb&scoped=true"
import script from "./Relatorios.vue?vue&type=script&lang=js"
export * from "./Relatorios.vue?vue&type=script&lang=js"
import style0 from "./Relatorios.vue?vue&type=style&index=0&id=37138abb&prod&scoped=true&lang=css"
import style1 from "./Relatorios.vue?vue&type=style&index=1&id=37138abb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37138abb",
  null
  
)

export default component.exports